import React from 'react';
import { Modal, ModalHeader, ModalContent, ModalFooter, RegularButton } from 'fronton-react';
import { modalButtonMobile, modalContentMobile, modalContentTablet } from './styles';

type OriginalProductModalProps = {
  mobile: boolean;
  open: boolean;
  onClose: () => void;
  text: {
    actionButton: string;
    header: string;
    paragraph: string;
  };
};

const DATA_QA_ORIGINAL_PRODUCT_MODAL = 'original-product-modal';
const DATA_QA_ORIGINAL_PRODUCT_MODAL_CLOSE = 'original-product-modal-close';

export const OriginalProductModal: React.FC<OriginalProductModalProps> = ({
  mobile,
  open,
  onClose,
  text: { actionButton, header, paragraph },
}) => {
  return (
    <Modal
      data-testid={DATA_QA_ORIGINAL_PRODUCT_MODAL}
      variant="curtain"
      modalID="original-product-modal"
      onClose={onClose}
      size="m"
      show={open}
    >
      <ModalHeader title={header} />
      <ModalContent className={mobile ? modalContentMobile : modalContentTablet}>{paragraph}</ModalContent>
      <ModalFooter>
        <RegularButton
          data-testid={DATA_QA_ORIGINAL_PRODUCT_MODAL_CLOSE}
          className={mobile ? modalButtonMobile : undefined}
          onClick={onClose}
          size="l"
          variant="secondary"
        >
          {actionButton}
        </RegularButton>
      </ModalFooter>
    </Modal>
  );
};
